import { useCallback } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useAppState } from 'src/AppContext';
import useCustomHistory from 'src/hooks/useCustomHistory';
import Icon from './Icon';
import useDrawer from 'src/components/Drawer';

function isInHome() {
  const matchStatus = useRouteMatch('/');
  return matchStatus && matchStatus.isExact;
}

function getHeaderClassNames() {
  const classNames = ['flex', 'h-13', 'items-center', 'justify-center', 'w-full'];
  if (isInHome()) {
    classNames.push('absolute');
  }
  return classNames.join(' ');
}

function getInnerClassNames() {
  const classNames = ['relative', 'flex', 'w-full', 'justify-center', 'items-center', 'h-13', 'container', 'z-50'];
  const customClassNames = isInHome() ? ['top-0', 'left-0', 'text-white'] : [];
  return classNames.concat(customClassNames).join(' ');
}

export default function Header(): JSX.Element {
  const history = useCustomHistory();
  const appStates = useAppState();
  const { openDrawer, DrawerComponent } = useDrawer();

  const showGNB = useCallback(() => {
    console.log('show gnb');

    openDrawer();
  }, []);

  const goBack = useCallback(() => {
    console.log('goBack');
    history.goBack();
  }, [history]);

  const goMyProducts = useCallback(() => {
    history.push('/product/my');
  }, []);

  const close = useCallback(() => {
    console.log('close');
  }, []);

  const leftButton = useCallback(() => {
    const left = appStates.gnbLeftButton;
    const callback = appStates.gnbLeftButtonCallback;
    const isBack = left === 'back';
    const onClickEvent = typeof callback === 'function' ? callback : isBack ? goBack : showGNB;
    return (
      <button onClick={onClickEvent} className={left === 'hidden' ? 'hidden' : 'block'}>
        <Icon name={isBack ? 'back' : isInHome() ? 'menu_w' : 'menu_b'} size="32" />
      </button>
    );
  }, [appStates]);

  const rightButton = useCallback(() => {
    const right = appStates.gnbRightButton;
    const callback = appStates.gnbRightButtonCallback;
    const isClose = right === 'close';
    const onClickEvent = typeof callback === 'function' ? callback : isClose ? close : goMyProducts;
    return (
      <button onClick={onClickEvent} className={right === 'hidden' ? 'hidden' : 'block'}>
        <Icon name={isClose ? 'close' : isInHome() ? 'ticket_w' : 'ticket_b'} size="32" />
      </button>
    );
  }, [appStates]);

  const onClickLogo = useCallback((e) => {
    e.preventDefault();
    history.push('/');
  }, []);

  const centerButton = useCallback(() => {
    const center = appStates.gnbCenterButton;
    return (
      <a href="#" onClick={onClickLogo} className={center ? 'block' : 'hidden'}>
        {isInHome() ? <Icon name="logo_s_b" size="90" sizeH="22" /> : <Icon name="logo_s" size="90" sizeH="22" />}
        {/* <h1 className={['service-name', isInHome() ? 'text-white' : 'text-black'].join(' ')}>
          <Icon name="logo_s" size="44" sizeH="29" />
        </h1> */}
      </a>
    );
  }, [appStates, onClickLogo]);

  return (
    <header className={getHeaderClassNames()}>
      <div className={getInnerClassNames()}>
        <div className="absolute left-5">{leftButton()}</div>
        {centerButton()}
        <div className="absolute right-5">{rightButton()}</div>
      </div>
      {DrawerComponent}
    </header>
  );
}
